<template lang="pug">
  div
    v-tabs(v-model='active' color="grey lighten-3"  grow )
      v-tab General
      v-tab-item
        General(
          @generalInfo="generalInfoSave" 
          :dataProduct="product" 
          @productEdited="productEdited"  
          :updateComponent="update" 
          
        )
      v-tab Comercial
      v-tab-item
        Comercial(
          @comercialInfo="comercialInfoSave" 
          :product="gInfo" 
          @productEdited="productEdited" 
          :dataProduct="product" 
          :updateComponent="update")
      v-tab Inventario
      v-tab-item
        Inventory(
          :product="gComercial" 
          :dataProduct="product" 
          @productEdited="productEdited" 
          :updateComponent="update"
          )
    
    
</template>

<script>
import General from '../showEdit/general/GeneralInformation'
import Comercial from '../showEdit/comercial/ComercialInformation'
import Inventory from '../showEdit/inventory/InventoryInformation'
import ItemModel from '@/models/Warehouse/WhItem'
/* services */
import ProductService from '@/services/api/product'
import PromoService from '@/services/api/promo'
/* vuex */
import {mapActions} from 'vuex'
export default {
  name: 'create-promo-tab-component',
  // props: {},
  data: function(){
    return {
      active: null,
      gInfo:{},
      gComercial:{},
      gInventory:{},
      model :new ItemModel(),
      product:{},
      update:false,
    }
  },
  //computed: {},
  methods: {
    // -- UI Modification
    // -- Data fetching
    // -- Data handling and transformations
    generalInfoSave(event){
      this.gInfo = event
      //this.nextTab()
    },
    /*
     */
    comercialInfoSave(event){
      //console.log(event,'comercila event')
      this.gComercial = event
      //this.nextTab()
    },
    // -- Validations and Error handling
    // -- Other functions
    /*
     */
    nextTab () {
      const active = parseInt(this.active)
      this.active = (active < 2 ? active + 1 : 0)
    },
    /*
     */
    async fetchProduct(){
      let resp = await PromoService.fetchById(this.$route.params.id)
      console.log(resp,'fetchPromo')
      let promoResp = await PromoService.fetchByIdPromo(resp.wh_promo_id)
      console.log(promoResp, 'promoresp')
      resp.wh_products_promo = promoResp.wh_products_promo
      this.product = resp
      this.update = false
      
    },
    /*
     */
    productEdited() {
     
      this.update =true
      this.fetchProduct()
    },

    // -- Vuex mappings
    ...mapActions('MenuesModule', {
      setTitleTopBar: 'setTitleTopBar',
    }),
  },
  // watch: {},
  components: {
    General,
    Comercial,
    Inventory,
  },
  // mixins: [],
  // filters: {},
  // -- Lifecycle Methods
  mounted(){
    this.fetchProduct()
  },
  beforeMount: function() {
      this.setTitleTopBar('EDICIÓN PROMOCIÓN')
    },
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  
</style>